export type TListener<T> = (data:T | undefined) => void

export class Hub<T>  {
    #data: T | undefined = undefined;
    #listeners = new Map<string, TListener<T>>()
    #url: string
    ws: WebSocket | null = null

    constructor(url: string) {
        this.#url = url
        // this.ws.addEventListener('message', (event) => {
        //     let data = JSON.parse(event.data)
        //     this.#data = data
        //     this.#echo(data) 
        // })
    }

    #conn() {
        this.ws = new WebSocket(this.#url);
        this.ws.addEventListener('message', (event) => {
            let data = JSON.parse(event.data)
            this.#data = data
            this.#echo(data) 
        })
    }

    #connOnce() {
        if(this.ws !== null) {
            return
        }
        this.#conn()
    }

    #disconn() {
        this.ws?.close()
        this.ws = null
    }

    #cleanConn() {
        if(this.#listeners.size !== 0) {
            return
        }
        setTimeout(() => {
            if(this.#listeners.size === 0) {
                this.#disconn()
            }
        }, 350)
    }

    data(): T | undefined {
        return this.#data
    }

    #echo(data: T) {
        this.#listeners.forEach((listener: TListener<T>) => {
            listener(data)
        });
    }

    listen(listener: TListener<T>): string {
        var id = "id" + Math.random().toString(16).slice(2)
        this.#listeners.set(id, listener)
        listener(this.#data)
        this.#connOnce()
        return id
    }

    remove(id: string) {
        this.#listeners.delete(id)
        this.#cleanConn()
    }


}